import styled from 'styled-components';

export const Content = styled.div`
  margin: 24px 16px;
  padding: 24px;
  background: #fff;
`;

export const PageHeader = styled.div`
  margin: 24px 16px;
  padding: 24px;
  background: #fff;
`;
